'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userCardDetails = exports.paymentTypes = exports.taxRate = undefined;

var _sagaTools = require('@classpass/saga-tools');

var taxRate = exports.taxRate = (0, _sagaTools.makeEntityScaffold)('SAGA.API.TAX_RATE', function (client, msaId, postalCode) {
  return client.taxes.getAmount({
    billing_info: { address: { postal_code: String(postalCode) } },
    msa_id: parseInt(msaId, 10)
  }).then(function (data) {
    return data.rate;
  });
}, { defaultKey: [1, 2] });

var paymentTypes = exports.paymentTypes = (0, _sagaTools.makeEntityScaffold)('SAGA.API.PAYMENT_TYPES', function (client, countryCode) {
  return client.transactions.paymentTypes(countryCode).then(function (data) {
    return data.data;
  });
}, { defaultKey: [1] });

var userCardDetails = exports.userCardDetails = (0, _sagaTools.makeEntityScaffold)('SAGA.API.CARD_DETAILS', function (client, userId) {
  return client.subscription.getV2(userId).then(function (data) {
    if (!data || !data.data || !data.data.card || !data.data.card.last_4) {
      return false;
    }

    return {
      name: data.data.card.name,
      lastFour: data.data.card.last_4,
      expMonth: data.data.card.exp_month,
      expYear: data.data.card.exp_year
    };
  });
}, { defaultKey: 1 });